













import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import CommonSelect from "@/components/common/CommonSelect.vue";
import {get} from "@/context/context";
import {Country} from "@/models/Country";
import {CountryService} from "@/services/CountryService";
import API from "@/utils/Api";
import {Servers} from "@/serverConfig";

@Component({
  components: {
    CommonSelect
  },
})
export default class CountrySelect extends Vue {
  @Prop()
  private value!: string;

  @Prop()
  private label?: string;

  @Prop()
  private name?: string;

  @Prop()
  private rules?: Array<any>;

  @Prop({default: ''})
  private errorMessage!: string;

  @Prop({default: false})
  private disabled!: boolean;

  @Watch('value')
  watchPropValue() {
    this.inputData = this.value;
  }

  @Watch('inputData')
  watchInputData() {
    this.$emit('input', this.inputData)
  }

  private inputData: string = '';
  private countries: Array<Country> = [];

  private countryService: CountryService = get('countryService');

  private async mounted() {
    this.countries = await this.countryService.getCountries();
  }

}
